import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Row } from 'reactstrap';
import { RowData } from "./components";

const ReadOnlyForm = (props) => {
  const { form, formControls } = props;

  return (
    <Form onSubmit={(e) => e.preventDefault()}>
      {
        form && form.map((row, index) => {
          return <RowData key={'RowData_' + index} row={row} />;
        })
      }
      <Row>
        {
          formControls.map((control, index) => {
            return (
              <Col key={`FormControl_${index}`} xs={`${parseInt(12 / formControls.length)}`}>
                <Button
                  block
                  {...control.props}>
                  {control.title}
                </Button>
              </Col>
            );
          })
        }
      </Row>
    </Form>
  );
};

ReadOnlyForm.propTypes = {
  form: PropTypes.array.isRequired,
  formControls: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    props: PropTypes.object.isRequired
  })).isRequired
};

export default ReadOnlyForm;